export const API_LINK = {
  ultra_mikro_list: `${process.env.MS_ULTRA_MIKRO_URL}/bribrain/umi/calon-mitra/rekomendasi`,
  ultra_mikro_detail: `${process.env.MS_ULTRA_MIKRO_URL}/bribrain/umi/calon-mitra/detail`,
  ultra_mikro_summary: `${process.env.MS_ULTRA_MIKRO_URL}/bribrain/umi/calon-mitra/total-kelolaan`,
  ultra_mikro_verifikasi: `${process.env.MS_ULTRA_MIKRO_URL}/bribrain/umi/calon-mitra/verifikasi-pks`,
};
